import { render, staticRenderFns } from "./views.vue?vue&type=template&id=067b5d22&"
import script from "./views.vue?vue&type=script&lang=js&"
export * from "./views.vue?vue&type=script&lang=js&"
import style0 from "./views.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports